import { useMemo } from 'react'

interface Props {
  children: React.ReactElement
  onClick?: () => void
  isSelected?: boolean
  isWrong?: boolean
  className?: string
}

const SelectionButton = ({
  children,
  onClick,
  isSelected = false,
  isWrong = false,
  className = '',
}: Props): React.ReactElement => {
  const buttonStateClass = useMemo(() => {
    if (isWrong) {
      return 'bg-red-wrong-choice text-white border-red-wrong-choice'
    }

    if (isSelected) {
      return 'bg-purple text-white'
    }

    return 'bg-white hover:bg-purple/20 text-purple border-purple'
  }, [isSelected, isWrong])

  return (
    <button
      className={`${buttonStateClass} border-2 rounded inline-block text-xs sm:text-lg font-semibold transition-colors ${className}`}
      onClick={onClick}
      type="button"
    >
      {children}
    </button>
  )
}

export default SelectionButton
